import axios from "axios";
import BASE_URL from "../../../constants/baseURL";

export default async function signOut(_, { getState }) {
  const { memberDetails } = getState();
  await axios({
    baseURL: BASE_URL.icici_logs.url + BASE_URL.icici_logs.version,
    url: "/vahan-logout",
    method: "POST",
    headers: {
      Authorization: "Bearer " + memberDetails.authToken,
      "Content-Type": "application/json",
    },
  });
}
